<template>
  <div :class="'project '+class_Type+' '+item.type"   >
    <img :src="item.photo" class="img-project" loading="lazy">
    <div class="project-info">
      <a :class="item.name+' stretched-link'"
         @click="openGallery"
         data-desc-position="right"
         data-effect="fade"
         data-width="900px"
         data-height="auto"
         data-zoomable="true"
         data-draggable="true"
      >
        <h6>{{item.name}}</h6>
        <p>{{item.tool}}</p>
      </a>

    </div>
  </div>
</template>

<script>

import  "glightbox/dist/css/glightbox.css";
import  "glightbox/dist/js/glightbox.js";
import GLightbox from 'glightbox';
export default {
  name: "VuePortfolioItem",
  props:{
    item:Object
  },
  data(){
    return{
      myGallery:{},
      class_Type:''
    }
  },

  mounted() {
    //lightbox settings
    this.myGallery = new GLightbox({
      selector: '.'+this.item.name,
      'touchNavigation': true,
      loop: true,
      elements:this.item.elements,
      openEffect: 'zoom',
      closeEffect: 'fade',

    });
    setTimeout(()=>{
          this.sizeBoxItem();
        },
    2000)


  },
  methods:{
    sizeBoxItem(){
      //let img = proj.value.firstElementChild;
      const img = new Image();
      img.src = this.item.photo;
      if(img.naturalWidth > img.naturalHeight && img.naturalWidth >=1800){
        this.class_Type='wide';
      }else if(img.naturalWidth < img.naturalHeight && img.naturalHeight>=1200){
        this.class_Type='tall';
      }else if(img.naturalWidth >=2200 && img.naturalHeight>=2200){
        this.class_Type='big';
      }else {
        this.class_Type='';
      }
    }
    ,
    openGallery(){
      this.myGallery.open();
    }
  }
}
</script>

<style scoped>
.project{
  max-width: 100%;
  height: 100%;
  vertical-align: middle;
  display: inline-block;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 0 5px rgba(0,0,0,0.5),0 0 10px rgba(0,0,0,0.8);
  overflow: hidden;
  padding: 0;
  cursor: pointer;
}
.project.wide{
  grid-column: span 2;
}
.project.tall{
  grid-row: span 2;
}
.project.big{
  grid-row: span 2;
  grid-column: span 2;
}

.project:before{
  content: "";
  position: absolute;
  left: 0;
  height: 5px;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border-bottom: 5px solid var(--primary-color);
  z-index: 3;
  border-radius: 12px;
  transform: translateY(100%);
  transition: all linear 0.3s 0.01s;
}
.project:hover:before{
  content: "";
  position: absolute;
  height: 5px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  border-bottom: 4px solid var(--primary-color);
  z-index: 3;
  border-radius: 12px;
  transform: translateY(0);
  transition: all linear 0.3s 0.01s;
}
.project .project-info{
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  bottom: -100%;
  background-color: rgba(0,0,0,0.7);
  backdrop-filter: blur(5px);
  z-index: 2;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all linear 0.3s 0.01s;

}

.project:hover  .project-info{
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,0.7);
  backdrop-filter: blur(5px);
  z-index: 2;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all linear 0.3s 0.01s;
}
.project .project-info h6{
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  color: var(--font-color);
}
.project .project-info p{
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}
.project img {

  width: 100%;
  height:100%;
  border-radius: 12px;
  z-index: 1;
  transition: all linear 0.3s 0.01s;
}
/*.project:hover > img {
  transform: scale(1.1);
  transition: all linear 0.3s 0.01s;
}*/
.stretched-link{
  cursor: zoom-in;

}
@media (max-width: 512px) {

  .project.wide{
    grid-column: span 1;
  }
  .project.tall{
    grid-row: span 1;
  }
  .project.big{
    grid-row: span 2;
    grid-column: span 1;
  }
}
</style>